import {SubscriptionModelV1} from 'resources/GeneratedModels/Subscription/SubscriptionModel.v1';

import {subscriptionModelValidators} from './SubscriptionModel.validators';

SubscriptionModelV1.addValidators(subscriptionModelValidators);

export {SubscriptionModelV1};
